import React from 'react';
import { Pressable, Platform, StatusBar } from 'react-native';
import { HStack, VStack, Actionsheet, Box, useColorModeValue, } from 'native-base';
import { useSafeAreaInsets, useSafeAreaFrame } from 'react-native-safe-area-context';
import { Text } from '../atoms';
function ActionButton({ disabled = false, fontToken = 'bodyBaseDefault', onPress, label, }) {
    return (React.createElement(Pressable, { disabled: disabled, onPress: onPress, accessibilityRole: "button" },
        React.createElement(Text, { fontToken: fontToken, color: disabled ? 'interactive.text.disabled' : 'interactive.text.active' }, label)));
}
export function BottomSheetModal({ children, closeIcon, closeButtonAccessibilityLabel, containerStyle, contentStyle, disableOverlay, disableOverlayClose = false, headerGap = 0, headerTitle, headerStyle, headerSubTitle, isOpen, leftActionButton, onClose, rightActionButton, showHeader = true, testID, testIDCloseButton, testIDSubTitle, testIDTitle, titleColorToken = 'text.100', type = 'hold-content', ...props }) {
    const barStyle = useColorModeValue('dark-content', 'light-content');
    // setup for safe area paddings and heights depending on 'header-gap' or 'fullscreen' modal type,
    // with default values representing for 'hold-content'
    const actionSheetProps = {};
    const actionSheetContentProps = {
        borderTopRadius: 16,
        pt: 4,
        px: 4,
        pb: 6,
    };
    const boxContainerProps = {};
    const boxContentProps = {};
    const frame = useSafeAreaFrame();
    const insets = useSafeAreaInsets();
    if (type === 'fullscreen') {
        actionSheetProps.height = frame.height;
        actionSheetContentProps.pt = `${insets.top}px`;
        actionSheetContentProps.borderTopRadius = 0;
        boxContainerProps.height = 'full';
        boxContentProps.height = 'full';
        boxContentProps.flex = 1;
    }
    else if (type === 'header-gap') {
        actionSheetProps.height = frame.height;
        actionSheetContentProps.mt = `${insets.top + headerGap}px`;
        boxContainerProps.height = 'full';
        boxContentProps.height = 'full';
        boxContentProps.flex = 1;
    }
    return (React.createElement(Actionsheet, { backgroundColor: "neutral.overlay", _backdrop: { bg: 'transparent' }, disableOverlay: disableOverlay, hideDragIndicator: true, isOpen: isOpen, onClose: disableOverlayClose ? undefined : onClose, testID: testID, ...actionSheetProps, ...props },
        React.createElement(Actionsheet.Content, { bgColor: "neutral.container", maxHeight: "100%", ...actionSheetContentProps },
            isOpen && Platform.OS === 'android' ? (React.createElement(StatusBar, { barStyle: type === 'fullscreen' ? barStyle : 'light-content' })) : null,
            React.createElement(Box, { width: "full", ...boxContainerProps, style: containerStyle },
                showHeader && (React.createElement(HStack, { style: headerStyle },
                    React.createElement(Box, { flexBasis: "80", alignItems: "flex-start", justifyContent: "center" },
                        closeIcon && (React.createElement(Pressable, { onPress: onClose, testID: testIDCloseButton, accessibilityRole: "button", accessibilityLabel: closeButtonAccessibilityLabel }, closeIcon)),
                        leftActionButton),
                    React.createElement(VStack, { alignItems: "center", flexBasis: "auto", flexGrow: 1, flexShrink: 1, justifyContent: "center" },
                        React.createElement(Box, null,
                            React.createElement(Text, { color: titleColorToken, ellipsizeMode: "tail", fontToken: "bodyLargeStrong", numberOfLines: 2, testID: testIDTitle, textAlign: "center" }, headerTitle)),
                        headerSubTitle && (React.createElement(Box, { alignItems: "center", justifyContent: "center" },
                            React.createElement(Text, { fontToken: "labelBaseDefault", color: "text.40", testID: testIDSubTitle }, headerSubTitle)))),
                    React.createElement(Box, { flexBasis: "80", alignItems: "flex-end", justifyContent: "center" }, rightActionButton))),
                React.createElement(Box, { mt: showHeader ? 2 : 0, justifyContent: "center", ...boxContentProps, style: contentStyle }, children)))));
}
BottomSheetModal.ActionButton = ActionButton;
